import React, { useState } from "react";
import { Loader2, CheckCircle, XCircle } from "lucide-react";

interface LoadingButtonProps {
  onClick: () => Promise<void>;
  children: React.ReactNode;
  className?: string;
}

export function LoadingButton({
  onClick,
  children,
  className = "",
}: LoadingButtonProps) {
  const [isLoading, setIsLoading] = useState(false);

  const showToast = (success: boolean, message: string) => {
    const toast = document.createElement("div");
    toast.className = `fixed bottom-4 right-4 flex items-center gap-2 px-4 py-2 rounded-lg text-white ${
      success ? "bg-green-500" : "bg-red-500"
    } shadow-lg transition-opacity duration-500`;

    const icon = success ? (
      <CheckCircle className="w-5 h-5" />
    ) : (
      <XCircle className="w-5 h-5" />
    );
    toast.innerHTML = `
      <div class="flex items-center gap-2">
        ${
          success
            ? '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></svg>'
            : '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></svg>'
        }
        <span>${message}</span>
      </div>
    `;

    document.body.appendChild(toast);

    setTimeout(() => {
      toast.style.opacity = "0";
      setTimeout(() => document.body.removeChild(toast), 500);
    }, 3000);
  };

  const handleClick = async () => {
    setIsLoading(true);
    try {
      await onClick();
      showToast(true, "Suksess!");
    } catch (error) {
      showToast(false, "En feil oppstod!");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={isLoading}
      className={`inline-flex items-center justify-center gap-2 px-4 py-2 font-medium text-black bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
    >
      {isLoading ? <Loader2 className="w-5 h-5 animate-spin" /> : null}
      {children}
    </button>
  );
}
